import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { type ReactElement } from 'react';

export const PsychoCardSkeleton = (): ReactElement => (
  <div className="relative w-full">
    <div className="flex gap-2 p-2 am-lg:p-4 rounded-xl w-full border border-teal-300">
      <Skeleton className="size-18 rounded-full hidden am-lg:block shrink-0" />
      <div className="w-full">
        <Skeleton className="absolute top-2 right-2 h-4 w-14 am-lg:hidden" />
        <div className="flex justify-between items-start gap-2">
          <div className="flex items-center gap-2">
            <Skeleton className="size-14 rounded-full am-lg:hidden shrink-0" />
            <div className="flex flex-col gap-1.5 am-lg:mb-4">
              <Skeleton className="h-4 w-36" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
          <Skeleton className="hidden am-lg:block h-4 w-16 shrink-0" />
        </div>
        <div className="flex flex-col gap-2 p-2 am-lg:p-0 am-lg:gap-3 am-lg:mb-6 mb-2">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-4/5" />
        </div>
        <div className="flex flex-col gap-4 px-2 am-lg:px-0 am-lg:flex-row am-lg:items-center am-lg:justify-between">
          <Skeleton className="h-4 w-28 rounded-full" />
          <Skeleton className="h-10 w-full am-lg:w-28 rounded-full" />
        </div>
      </div>
    </div>
  </div>
);
